import {axios} from "../../config/axios"

export const autoCampaignAPI = {
  /**
   * Retrieve all available advertisers connect to current merchant
   * @param {number} autoCampaignId - current auto campaign's id
   * @param {string} searchTerm - optional, if user enters any search terms
   */
  getBrands(currentPage, searchTerm) {
    const params = { page: currentPage }
    if (searchTerm) params.search = searchTerm
    return axios.get(`/api/v3/brands`, { params: params })
      .then(resp => resp.data)
  },

  /**
   * Updates the selected groups for a campaign
   *
   * @param {number} scopeID,
   * @param {number} autocampaignID,
   * @param {{
   *  merchant_segment_ids: Array.<number>
   *  date_range: Date
   * }} params Options for updating groups
   * @returns Promise.<{
   *  groups_with_selected: Array.Object
   *  merchant_segment_ids: Array.number
   *  merchant_tag_ids: Array.Number
   *  sub_configuration: Object.<{ max_date: string, min_date: string }>
   * }>
   */
  async updateGroups(scopeID, autocampaignID, params) {
    const resp = await axios.patch(`/api/v3/auto_campaign_scopes/${scopeID}`, {
      'auto_campaign_scope': params
    }, {
      params: {
        'auto_campaign_id': autocampaignID
      }
    });
    return resp.data;
  },
}
